import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <img src="/hsfl-logo.svg" alt="HSFL Logo" className="hero-logo" />
          <h1 className="hero-title">Highschool Football League</h1>
          <p className="hero-subtitle">Elite Roblox Football Competition | EST. 2017</p>
          <p className="hero-description">Experience competitive high school football action at the highest level.</p>
          <Link to="/stats" className="cta-button">View Stats</Link>
        </div>
      </section>

      <section className="features">
        <div className="feature-grid">
          <div className="feature-card">
            <h3>📊 Live Stats</h3>
            <p>Track player performance and team statistics across all positions.</p>
          </div>
          <div className="feature-card">
            <h3>🏆 Rankings</h3>
            <p>See where teams and players stand in the official HSFL rankings.</p>
          </div>
          <div className="feature-card">
            <h3>⚡ Scores</h3>
            <p>Get live game updates and final scores from every matchup.</p>
          </div>
          <div className="feature-card">
            <h3>📰 News</h3>
            <p>Stay informed with the latest HSFL news and league updates.</p>
          </div>
        </div>
      </section>

      <section className="quick-links">
        <div className="links-container">
          <Link to="/stats" className="link-button">
            <span>📈</span>
            <span>Player Stats</span>
          </Link>
          <Link to="/scores" className="link-button">
            <span>🎯</span>
            <span>Game Scores</span>
          </Link>
          <Link to="/rankings" className="link-button">
            <span>🥇</span>
            <span>Rankings</span>
          </Link>
          <Link to="/rulebook" className="link-button">
            <span>📋</span>
            <span>Rulebook</span>
          </Link>
        </div>
      </section>

      <section className="footer-section">
        <h2>Welcome to HSFL</h2>
        <p>The premier destination for Roblox football enthusiasts. Founded in 2017, the Highschool Football League has grown to become a competitive platform where players showcase their skills.</p>
      </section>
    </div>
  );
}

export default Home;
